import React from 'react';
import { Text } from 'ui';
import { Link } from 'react-router-dom';
import { useAuth } from 'api';

export default function QuickLinks() {
  return (
    <div className="quicklinks">
      <Welcome style={{marginRight:60}}/>
      <div className="quicklinks-links">
        <Text white large style={{marginRight:32, whiteSpace:'nowrap'}}>Tap to</Text>
        <Tag to="/campaigns/create" color="#00b2a8">
          Start a<br/>
          Campaign
        </Tag>
        <Tag to="/pages/create" color="#5cc2e8">
          Design a<br/>
          Landing Page
        </Tag>
        <Tag to="/tags/create" color="#fa637d">
          Design<br/>
          an NFC Tag
        </Tag>
        <Tag to="/media" color="#ffd100">
          Upload<br/>
          Media
        </Tag>
      </div>
    </div>
  );
}


function Welcome({style}) {
  const auth = useAuth();
  if(!auth) {
    return null;
  }
  return (
    <div className="quicklinks-welcome" style={{flex:'0 0 auto', ...style}}>
      <Text semibold white>Hi, {auth.displayName}! </Text>
      <Text white>Here are some shortcuts to get you started:</Text>
    </div>
  );
}

function Tag({color="#ffffff", to, children}) {
  return (
    <Link to={to} style={{display:'block', position:'relative', margin:"6px 32px 0 0", textDecoration:'none'}}>
      {/*
      <svg height={45} viewBox="0 0 207.57 75.43">
        <g>
        	<g>
        		<path fill={color} d="M0.26,27.96c1.44,2.9,2.32,6.12,2.32,9.57c0,3.65-0.99,7.04-2.58,10.06l7.11,7.11
        			c3.24-4.94,5.14-10.84,5.14-17.17c0-6.14-1.8-11.86-4.85-16.71L0.26,27.96z"/>
        	</g>
        	<g>
        		<path fill={color} d="M14.37,13.86c4.74,6.7,7.56,14.86,7.56,23.67c0,9.01-2.95,17.32-7.88,24.1l6.9,6.9
        			c6.65-8.59,10.65-19.32,10.65-31c0-11.48-3.88-22.06-10.33-30.57L14.37,13.86z"/>
        	</g>
        	<path fill={color} d="M28.17,0c8.18,10.32,13.11,23.32,13.11,37.48c0,14.35-5.05,27.53-13.43,37.91v0.04h179.72V0H28.17"/>
        </g>
      </svg>
      */}
      <svg height={45} viewBox="0 0 235.57 75.43">
        <path fill={color} d="M0.26,27.96c1.44,2.9,2.32,6.12,2.32,9.57c0,3.65-0.99,7.04-2.58,10.06l7.11,7.11
        	c3.24-4.94,5.14-10.84,5.14-17.17c0-6.14-1.8-11.86-4.85-16.71L0.26,27.96z"/>
        <path fill={color} d="M14.37,13.86c4.74,6.7,7.56,14.86,7.56,23.67c0,9.01-2.95,17.32-7.88,24.1l6.9,6.9
        	c6.65-8.59,10.65-19.32,10.65-31c0-11.48-3.88-22.06-10.33-30.57L14.37,13.86z"/>
        <path fill={color} d="M28.17,0c8.18,10.32,13.11,23.32,13.11,37.48c0,14.35-5.05,27.53-13.43,37.91v0.04h207.72V0H28.17"/>
      </svg>
      <Text size={14} style={{position:'absolute', top:6, right:0, width:110}}>
        {children}
      </Text>
    </Link>
  );
}






